<template>
    <div class="intelligence-kpis">
        <div v-for="card in cards" :key="card.key" class="intelligence-kpis__card">
            <p class="intelligence-kpis__label">{{ card.label }}</p>
            <p class="intelligence-kpis__value">{{ card.displayValue }}</p>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            kpis: {
                type: Object,
                default: () => ({}),
            },
        },

        computed: {
            cards() {
                const kpis = this.kpis || {}

                return [
                    {
                        key: 'totalActions',
                        label: this.$t('pages.intelligence.patient_friction.kpis.total_actions'),
                        displayValue: this.formatCount(kpis.totalActions),
                    },
                    {
                        key: 'uniqueReferralsWithAction',
                        label: this.$t('pages.intelligence.patient_friction.kpis.unique_referrals'),
                        displayValue: this.formatCount(kpis.uniqueReferralsWithAction),
                    },
                    {
                        key: 'actionCompletionRate',
                        label: this.$t('pages.intelligence.patient_friction.kpis.completion_rate'),
                        displayValue: this.formatPercent(kpis.actionCompletionRate),
                    },
                    {
                        key: 'averageHoursToFirstAction',
                        label: this.$t('pages.intelligence.patient_friction.kpis.hours_to_first'),
                        displayValue: this.formatHours(kpis.averageHoursToFirstAction),
                    },
                ]
            },
        },

        methods: {
            formatPercent(value) {
                if (value === null || value === undefined) return '—'
                return `${value}%`
            },

            formatCount(value) {
                if (value === null || value === undefined) return '—'
                return value
            },

            formatHours(value) {
                if (value === null || value === undefined) return '—'
                return `${value}h`
            },
        },
    }
</script>

<style lang="scss" scoped>
    .intelligence-kpis {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
        gap: 16px;
    }

    .intelligence-kpis__card {
        background: #fff;
        border: 1px solid #e5e7eb;
        border-radius: 12px;
        padding: 20px;
    }

    .intelligence-kpis__label {
        margin: 0 0 8px;
        font-size: 13px;
        color: #6b7280;
    }

    .intelligence-kpis__value {
        margin: 0;
        font-size: 28px;
        font-weight: 700;
        color: #111827;
    }
</style>
